export default __webpack_public_path__ + "static/media/06a3d5bb601cd02f.94890cce1cdd1cdf74886485415e46e0.svg";